import { Balloon } from '~/app/(default-layout)/s/[storyId]/_components/chat-script-render/op/balloon';
import type { TypingNow as TypingNowOp } from '~/app/_types/chat-script';
import { css } from '@styled-system/css';
import { Circle, HStack } from '@styled-system/jsx';

type Props = {
  op: TypingNowOp;
};

export const TypingNow = ({ op }: Props) => {
  return (
    <Balloon character={op.character} withTip>
      <HStack>
        <Circle className={css(ballBase)} />
        <Circle
          className={css(
            ballBase,
            css.raw({
              animationDelay: '0.5s',
            })
          )}
        />
        <Circle
          className={css(
            ballBase,
            css.raw({
              animationDelay: '0.75s',
            })
          )}
        />
      </HStack>
    </Balloon>
  );
};

const ballBase = css.raw({
  w: '13px',
  h: '13px',
  borderRadius: '100%',
  mr: '2px',
  ml: '2px',
  bgColor: '#fff',
  display: 'inline-block',
  animation: 'typing-now-ball 1s 0s infinite linear',
});
